<template>
  <form
    class="flex min-h-full min-w-full grow flex-col"
    @submit="onSubmit"
  >
    <div
      class="mb-6 w-full flex-1 justify-between space-y-6"
    >
      <FormInputText name="label" label="Tag Label" />

      <FormInputNamedColor
        :options="productTagColorOptions"
        name="color"
        label="Display Color"
      />

      <FormInputCheckbox
        name="isHidden"
        label="Hide tag?"
      />
    </div>

    <div class="flex justify-end gap-2">
      <button
        type="button"
        class="flex-1 text-center text-primary"
        @click="emit('cancel')"
      >
        Cancel
      </button>
      <FormSubmitButton
        class="flex-1"
        :is-submitting="isSubmitting"
      >
        Save Tag
      </FormSubmitButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import z from "zod"
import { productTagColors } from "@/services/product-tags/productTagColors"
import { assertIsNonEmptyArray } from "@/utils/assertIsNonEmptyArray"
import { requiredTrimmedString } from "@/validation/sharedStringFieldSchemas"

const props = withDefaults(
  defineProps<{
    initialValues?: CreateUpdateProductTagBody
    isSubmitting: boolean
  }>(),
  {
    initialValues: () => ({
      label: "",
      color: "grey",
      isHidden: false,
    }),
  }
)
const emit = defineEmits<{
  (
    event: "submit",
    params: CreateUpdateProductTagBody
  ): void
  (event: "cancel"): void
}>()

const productTagFormSchema = z.object({
  label: requiredTrimmedString("Tag label is required"),
  color: z.enum(assertIsNonEmptyArray(productTagColors)),
  isHidden: z.boolean(),
})

const { handleSubmit } = useForm({
  validationSchema: toTypedSchema(productTagFormSchema),
  initialValues: props.initialValues,
})

const onSubmit = handleSubmit(async (params) => {
  emit("submit", params)
})
</script>
